import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-brand-cream py-20 px-4 text-center" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <motion.h2 className="text-4xl md:text-6xl font-black text-brand-darkGreen mb-10 leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-87">
          Empezá hoy a resolver tus viandas sin estrés
        </motion.h2>

        <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 mb-12" data-id="element-88">
          {['Recetas fáciles', 'Organización simple', 'Ideas reales para todos los días'].map((item, index) => <motion.div key={index} className="flex items-center justify-center gap-2" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-89">
              <span className="text-brand-green font-bold text-xl" data-id="element-90">✔</span>
              <span className="text-xl font-bold text-gray-800" data-id="element-91">{item}</span>
            </motion.div>)}
        </div>

        <motion.div className="mb-8" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} data-id="element-92">
          <span className="bg-brand-orange/10 text-brand-orange font-bold text-xl px-6 py-2 rounded-full border border-brand-orange/20" data-id="element-93">
            👉 Todo en un solo lugar
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} data-id="element-94">
          <Button className="text-xl md:text-3xl py-5" data-id="element-95">
            QUIERO EL EBOOK AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}